import type { Board } from '../../../../../api/projects-client/projects-client.type';
import { FiltersList } from './filters-list';

type Props = {
  boards: Board[];
  selectedBoards: Board[];
  onSelectBoards: (boards: Board[]) => void;
};

export const FiltersListBoards = ({ boards, selectedBoards, onSelectBoards }: Props) => {
  return (
    <FiltersList
      items={boards}
      selectedItems={selectedBoards}
      onSelectItems={onSelectBoards}
      getItemName={(board) => board.name}
    />
  );
};
